module.exports = __webpack_public_path__ + "img/Döner.db23e94a.svg";